import { LayoutGrid, AlertTriangle, FileSearch, CheckCircle, XCircle, Clock } from 'lucide-react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';

interface RequestStatsCardsProps {
  stats: {
    total: number;
    pending: number;
    approved: number;
    completed: number;
    rejected?: number;
    overdue?: number;
  };
}

export function RequestStatsCards({ stats }: RequestStatsCardsProps) {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng đề xuất',
      value: stats.total || 0,
      suffix: 'Tất cả',
      icon: LayoutGrid,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'neutral',
      trendValue: 'Tổng quan',
      chartColor: 'bg-blue-500',
      chartData: [10, 15, 12, 18, 20]
    },
    {
      title: 'Chờ xử lý',
      value: stats.pending || 0,
      suffix: 'Mới',
      icon: AlertTriangle,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'up',
      trendValue: 'Đang chờ',
      chartColor: 'bg-amber-500',
      chartData: [5, 4, 6, 8, 5]
    },
    {
      title: 'Đã duyệt',
      value: stats.approved || 0,
      suffix: 'Sẵn sàng',
      icon: FileSearch,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Tiến độ',
      chartColor: 'bg-indigo-500',
      chartData: [2, 5, 8, 9, 10]
    },
    {
      title: 'Hoàn thành',
      value: stats.completed || 0,
      suffix: 'Xuất kho',
      icon: CheckCircle,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Thành công',
      chartColor: 'bg-emerald-500',
      chartData: [1, 2, 5, 8, 12]
    },
    {
      title: 'Từ chối',
      value: stats.rejected || 0,
      suffix: 'Hủy bỏ',
      icon: XCircle,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'down',
      trendValue: 'Lỗi',
      chartColor: 'bg-rose-500',
      chartData: [0, 1, 0, 2, 0]
    },
    {
      title: 'Quá hạn',
      value: stats.overdue || 0,
      suffix: 'Cảnh báo',
      icon: Clock,
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      trend: 'down',
      trendValue: 'Chậm trễ',
      chartColor: 'bg-purple-500',
      chartData: [0, 0, 1, 0, 1]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
